const imgData_2022 = {
  peeking: {
    title: 'Peeking',
    imgs: {
      full: {
        src: require('./peeking_2022_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./peeking_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description: 'Ink and watercolour on paper. 210 x 297 mm, 2022.',
    price: 90,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "A commissioned piece, the last of 2022. The request was that I paint a heron portrait, that from the distance looks nothing special but a heron portrait, but if you examine the details close up, you can see the client's cats!",
  },
  red_deer: {
    title: 'Red Deer',
    imgs: {
      full: {
        src: require('./red_deer_2022_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./red_deer_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Pen, markers and coloured pencils on paper. 210 x 297 mm, 2022.',
    price: 90,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1331985676/',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "I used markers and coloured pencils this time instead of my usual watercolours so the result is this really vivid piece. Available unframed, but can be mounted optionally.<br /><br />This is a true Irish concept: the Red Deer is Ireland's only native deer species, and the evergreens around are also native plants of the island: holly, juniper, ivy and scots pine.",
  },
  blue_tits: {
    title: 'Blue Tits',
    imgs: {
      full: {
        src: require('./blue_tits_2022_all_web.jpg'),
        width: 1473,
        height: 1500,
      },
      thumb: {
        src: require('./blue_tits_2022_all_thumb.jpg'),
        width: 589,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Watercolour, acrylics and gauche on paper. 73 x 250 mm each, 2022.',
    price: 96,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "I used only 4 colours to paint them: yellow, blue, black and white. My usual ink outlines were replaced by thin gauche lines and all the colours were mixed from these bases. Thanks to this limited palette the 3 mini paintings really go well together, that's why I decided to sell them as a set. They need to stay together like siblings!",
  },
  the_fairy_fox: {
    title: 'The Fairy Fox',
    imgs: {
      full: {
        src: require('./the_fairy_fox_2022_web.jpg'),
        width: 1106,
        height: 1500,
      },
      thumb: {
        src: require('./the_fairy_fox_2022_thumb.jpg'),
        width: 442,
        height: 600,
      },
    },
    year: '2022',
    description: 'Ink and watercolour on paper. 148 x 210 mm, 2022.',
    price: 96,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1252442778/',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "For a change instead of black ink the lines are done with scarlet ink. This goes really well with the colours! I usually prefer tubed watercolours (easier to mix) but I was happy with these ones after all. You can see how small they are, and such a little sample goes a long way!<br /><br />Originally the fern and foxgloves weren't planned but I misplaced the fox and once I noticed I was too far in the process... So I improvised.",
  },
  rooster_iii: {
    title: 'Rooster III',
    imgs: {
      full: {
        src: require('./rooster_iii_2022_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./rooster_iii_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description: 'Watercolour on paper. 148 x 210 mm, 2022.',
    price: 96,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1253620064/',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "No ink here! Although that's a fundamental tool of my style I'm quite happy with how things turned out. Instead an ink outline I used the darkest shade of the watercolours with very little water (so the pigment concentration would be high) and added the outlines at the end of the painting process.",
  },
  not_today_but_one_day: {
    title: 'Not Today, but One Day',
    imgs: {
      full: {
        src: require('./not_today_one_day_2022_web.jpg'),
        width: 1500,
        height: 888,
      },
      thumb: {
        src: require('./not_today_one_day_2022_thumb.jpg'),
        width: 600,
        height: 355,
      },
    },
    year: '2022',
    description:
      'Ink and watercolour on Arches HP 300gsm paper. 560 x 380 mm, 2022.',
    price: 356,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1273867919/',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'One adventurous fox and a flock of geese with earthy colours and Irish forest undergrowth.',
  },
  gyrflacon: {
    title: 'Gyrfalcon',
    imgs: {
      full: {
        src: require('./gyrfalcon_2022_web.jpg'),
        width: 1074,
        height: 1500,
      },
      thumb: {
        src: require('./gyrfalcon_2022_thumb.jpg'),
        width: 430,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Ink and liquid pencil paint on 400gsm board. 136 x 190 mm, 2022.',
    price: 86,
    original: 'MSG',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "Ever since I could hold a pencil, if you put a blank sheet of paper, or just _anything_ white in front of me, I eventually drew something on it. Maybe that's the reason why I started saving scraps of paper... I have a folder full of leftover pieces I just find too valuable to throw away.<br /><br />When I mounted <i>Curls</i> I had this nice leftover piece of heavy mounting board that I cut from the inside of the mount. It's an inverse, so it felt like some plaque... and it was pure white. Of course I had to save it!<br /><br />This gyrfalcon I encountered in Sligo at a birds of prey centre. Being such a majestic bird I thought he would fit this 'plaque' and the colours of the reference photos I took were also perfect for an experiment with liquid pencils. I mixed these with traditional watercolours to give some depth at some places, and also mixed a special shade of dark blue for the ink lines.",
  },
  curls: {
    title: 'Curls - a study',
    imgs: {
      full: {
        src: require('./curls_2022_web.jpg'),
        width: 1500,
        height: 1061,
      },
      thumb: {
        src: require('./curls_2022_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2022',
    description:
      'Ink and watercolour on Saunders Waterford watercolour paper. 194 x 139 mm, 2022.',
    price: 90,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1204809778/',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "I took a series of photos of this magnificent ram in Wicklow and among the pictures there was this one from the side, highlighting those curly horns. It was too good not to paint it!<br /><br />What a majestic animal, I'm in love with him! Sheep is overlooked. On the Irish fields you can walk among them without barriers, and once you stop to look you'll see they are much more than just livestock. The pride and endurance of their wild ancestry is still there and they thrive comfortably among the mountains of Wicklow, in rain, wind or hail.",
  },
  dollymount: {
    title: 'Dollymount',
    imgs: {
      full: {
        src: require('./dollymount_2022_web.jpg'),
        width: 1000,
        height: 1058,
      },
      thumb: {
        src: require('./dollymount_2022_thumb.jpg'),
        width: 600,
        height: 635,
      },
    },
    year: '2022',
    description:
      'Ink and watercolour on 400gsm watercolour paper. 156 x 166 mm, 2022.',
    price: 90,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 24,
    buyUrl: 'https://www.etsy.com/ie/listing/1420432745/',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'This is a painting I made as an entry to the yearly World Curlew Day Art and Poetry competition organised by Curlew Action, an organisation dedicated to the conservation of nesting curlews in the UK and Ireland.<br /><br />Although curlews are a common sight, nesting pairs are disappearing from the Irish and British shores as their nesting grounds are no longer safe. The profits from selling this painting go to fund the hard work Curlew Action is doing.<br /><br />The painting was named after the shore of Bull Island where I see most of the curlews I encounter.',
  },
  berry_thief: {
    title: 'Berry Thief',
    imgs: {
      full: {
        src: require('./berry_thief_2022_web.jpg'),
        width: 1060,
        height: 1500,
      },
      thumb: {
        src: require('./berry_thief_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Ink and watercolour on 300gsm watercolour paper. 210 x 297 mm, 2022.',
    price: 106,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1189872037/',
    merch: [
      {
        name: 'Colouring Page - Printed',
        url: 'https://www.etsy.com/ie/listing/1171078013/',
        /* prettier-ignore */
        price: 3.50,
        discount: 0,
      },
    ],
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "This magpie started out as a quicky based on an idea I had about the floral elements planned for a larger piece.<br /><br />I've dug into the matter of Irish butterflies too, and picked the amazing red admiral to add some spice to this painting. I'm not very much into insects, except when it comes to butterflies, bees/bumblebees and grasshoppers, so I'm going to make these guys part of my artworks more often.<br /><br />The plants pictured here are heavily influenced by the native Irish forests, especially the Rowan tree that I love with its red berries.",
  },
  acer_palmatum: {
    title: 'Acer Palmatum',
    imgs: {
      full: {
        src: require('./acer_palmatum_2022_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./acer_palmatum_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Ink and watercolour on 250gsm watercolour paper. 148 x 210 mm, 2022.',
    price: 120,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 23.5,
    buyUrl: 'https://www.etsy.com/ie/listing/1419570413/',
    merch: [
      {
        name: 'Colouring Page - Printed',
        url: 'https://www.etsy.com/ie/listing/1159317277/',
        /* prettier-ignore */
        price: 3.50,
        discount: 0,
      },
      {
        name: 'Colouring Page - Digital',
        url: 'https://www.etsy.com/ie/listing/1184420586/',
        /* prettier-ignore */
        price: 4.37,
        discount: 0,
        digital: true,
      },
    ],
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "Japanese woodblock printing is one of my favourite, most inspiring art forms, and I loved arranging the composition and colours based on that style. This is something I'd like to discover more as the core of this type of art is very much the same as my reason for painting: to capture the soul and spirit of the living world!",
  },
  affection: {
    title: 'Affection',
    imgs: {
      full: {
        src: require('./affection_2022_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./affection_2022_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2022',
    description:
      'Ink and watercolour on 300gsm watercolour paper. 297 x 420 mm, 2022.',
    price: 120,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 25.5,
    buyUrl: 'https://www.etsy.com/ie/listing/1397110214/',
    merch: [
      {
        name: 'Greeting Cards',
        url: 'https://www.etsy.com/ie/listing/1159323797/',
        /* prettier-ignore */
        price: 4.90,
        discount: 0,
      },
    ],
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'Like most of the best stories the story of "Affection" was written by life. When I was about 8-9 I was encouraged to participate in school drawing contests. There was a contest at Valentine\'s Day themed "Love", of course. All my classmates drew hearts and doves and pink things, but being the one who was into dinosaurs (I knew the Latin name for every breed, a real geek!) while others wanted princesses I took a different path: to me love was a deer being licked by another. Affection.',
  },
};

export default imgData_2022;
